// src/App.jsx
import React from "react";
import AppRouter from "./routes/AppRouter";

export default function App() {
    return <AppRouter />;
}
